export const dateShortFormatU = 'DD-MM-YYYY';
export const dateShortFormatL = 'dd-MM-yyyy';
export const dateShortFormatD = 'DD.MM.YYYY';
export const timeDateFormat = 'HH:mm DD.MM.YYYY';
